const queryClientConfig = {
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
};

export default queryClientConfig;
